import { z } from '@authy/lib-common/utils/zod'

const optionalUrl = () => z.union([z.literal(''), z.url()]).default('')

export const AppEnvSchema = z.object({
    VITE_PRODUCT_KEY: z.enum(['authy']),
    VITE_PRODUCT_ENV: z.enum(['development', 'production']),
    VITE_PRODUCT_NAME: z.string().min(1),
    VITE_PRODUCT_ENDPOINT: z.url(),
    VITE_PRODUCT_URL_ROOT: z.url(),
    VITE_PRODUCT_URL_ACCOUNT: z.url(),
    VITE_PRODUCT_URL_SUBPATHS: z.string().default(''),

    VITE_AUTH_PROVIDER_ISSUER: z.url(),
    VITE_AUTH_PROVIDER_CLIENT_ID: z.string(),

    VITE_SECURITY_SETTINGS_URL: z.url(),

    VITE_GIPHY_API_KEY: z.string(),
    VITE_MAPBOX_TOKEN: z.string(),

    VITE_PRODUCT_VERSION: z.string().default(''),
    VITE_PRODUCT_RELEASE: z.string().default(''),
    VITE_PRODUCT_RELEASE_TIME: z.string().default(''),

    VITE_SENTRY_DSN_WEB: optionalUrl(),
})

export type AppEnv = z.infer<typeof AppEnvSchema>
